import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { IDualPlaybackLayoutOption } from './IDualPlaybackLayoutOption';
import { PLAYER_USER_PREFERENCE_KEY } from '../../player/shared/userPreference/PlayerUserPreferenceHandler';
import { userAgentUtil } from '../../player/UserAgentUtil';

import { PlayerUserPreferencesService } from '../../player/shared/userPreference/PlayerUserPreference.Service';
import { VbBaseMenuComponent } from '../../player/shared/VbBaseMenu.Component';
import { VideogularComponent } from '../../player/videogular/Videogular.Component';

import { IVbSource } from '../../player/IVbSource';

@Component({
	selector: 'vb-dual-playback-layout-menu-button',
	host: {
		'[class.smallSizePlayer]': 'isSmallSizePlayer'
	},
	template: `
		<div
			class="dropdown"
			dropdown
			#dropdown="bs-dropdown"
			placement="top right"
			[dropup]="true"
			[insideClick]="true"
			[hidden]="!vgApi.isDualPlayback">

			<button
				class="dualPlaybackMenuButton menuButton vb-icon vb-icon-content-and-speaker"
				id="buttonLayoutMenu"
				type="button"
				[tooltip]="translations['dualPlaybackLayoutViews']"
				[placement]="'top'"
				[attr.aria-label]="translations['dualPlaybackLayoutViews']"
				vbControlBarFocus
				dropdownToggle>
			</button>

			<div *dropdownMenu
				#vbDropdownMenu
				tabindex="0"
				id="dropdownLayoutMenu"
				aria-labelledby="buttonLayoutMenu"
				class="dropdown-menu dualPlaybackDropdownMenu dropdownMenu">
				<div class="optionButtonsWrapper">
					<button
						type="button"
						class="optionButton"
						(click)="updateToContentOnlyLayout()"
						[attr.aria-label]="translations.fullViewContent">
						<span class="vb-icon vb-icon-content-only"></span>
					</button>
					<button
						type="button"
						class="optionButton"
						(click)="updateToSpeakerOnlyLayout()"
						[attr.aria-label]="translations.fullViewSpeaker">
						<span class="vb-icon vb-icon-speaker"></span>
					</button>
				</div>
				<ul class="layoutOptionsWrapper"
					role="menu">
					@for (layoutOption of layoutOptions; track layoutOption.id) {
						<li tabindex="0" role="menuitem"
							class="layoutOption"
							[ngClass]="layoutOption.id === vgApi.dualPlaybackLayout.id ? 'active' : ''"
							[attr.aria-label]="translations[layoutOption.id]"
							(keyup)="onKeyupEvent($event, layoutOption)"
							(click)="updateSelection(layoutOption)">
						</li>
					}
				</ul>
			</div>
		</div>`,
	standalone: false,
	styleUrls: ['./VbDualPlaybackLayoutMenuButton.Component.ng.less', '../../player/MenuButton.ng.less'],
})
export class VbDualPlaybackLayoutMenuButtonComponent extends VbBaseMenuComponent implements OnChanges, OnInit {
	@Input() public isSmallSizePlayer: boolean;
	@Input() public layoutOptions: IDualPlaybackLayoutOption[];
	@Input() public sources: IVbSource[];
	public readonly userAgentUtil = userAgentUtil;

	constructor(
		protected readonly PlayerUserPreferencesService: PlayerUserPreferencesService,
		public vgApi: VideogularComponent
	) {
		super();
	}

	public ngOnInit(): void {
		super.ngOnInit();
		// set initial value to the first option
		this.resetSelection();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		// reset the selection when the sources change
		if (changes.sources) {
			this.resetSelection();
		}
	}


	public resetSelection(): void {
		if (this.layoutOptions?.length) {
			const userPreferenceLayout = this.PlayerUserPreferencesService.getPreference<IDualPlaybackLayoutOption>(PLAYER_USER_PREFERENCE_KEY.DUAL_PLAYBACK);
			const defaultOption = userPreferenceLayout || this.layoutOptions.find(option => option.isDefault) || this.layoutOptions[0];
			this.vgApi.setDualPlaybackLayout(defaultOption);
		}
	}

	public updateToContentOnlyLayout(): void {
		this.updateSelection(this.layoutOptions.find(option => option.isContentOnly));
	}

	public updateToSpeakerOnlyLayout(): void {
		this.updateSelection(this.layoutOptions.find(option => option.isSpeakerOnly));
	}

	/**
	 * TODO - Add anchor tag inside li tag and move click event to it.
	 * Having a click event on li tag not semantically correct.
	 */
	public onKeyupEvent(event: KeyboardEvent, layoutOption: IDualPlaybackLayoutOption) {
		const target = event.target as HTMLElement;

		if (target.tagName === 'LI' && event.key === 'Enter') {
			this.updateSelection(layoutOption);
		}
	}

	public updateSelection(layoutOption: IDualPlaybackLayoutOption): void {
		this.vgApi.setDualPlaybackLayout(layoutOption);
		this.PlayerUserPreferencesService.setPreference(PLAYER_USER_PREFERENCE_KEY.DUAL_PLAYBACK, layoutOption);
	}
}
